import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
// import Swal from 'sweetalert2';
import { updateUserProfile } from '../../../actions/homeAction.js';
// import Constant from '../../../Constant.js';

// export default UsersAdd

const UsersAdd = ({ data }) => {
  // class UserAdd extends React.Component {
  const [detail, setDetail] = useState({
    username: '',
    firstName: '',
    lastName: '',
    password: '',
    rePassword: '',
    // email:'',
    countryCode: '',
    mobileNumber: '',
    mobileVerified: '',
    status: '',
  });

  const userType = data?.userType;

  console.log(userType);

  // console.log("data", data, detail);
  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      setDetail({
        username: data?.username,
        // email:data?.email,
        firstName: data?.firstName,
        lastName: data?.lastName,
        countryCode: data?.countryCode,
        mobileNumber: data?.mobileNumber,
        mobileVerified: data?.mobileVerified,
        status: data?.status,
        password: '',
        rePassword: '',
      });
    }
  }, [data]);

  const onChangeHandle = (e) => {
    const { name, value } = e.target;
    // console.log(name, value);
    setDetail({ ...detail, [name]: value });
  };

  const passTrue = detail.password === detail.rePassword;

  const dispatch = useDispatch();
  const onSave = () => {
    if (passTrue) {
      // alert('asds')
      const dataObj = {
        userId: data?.userId,
        username: detail.username,
        firstName: detail.firstName,
        lastName: detail.lastName,
        countryCode: detail.countryCode,
        mobileNumber: detail.mobileNumber,
        mobileVerified: detail?.mobileVerified,
        password: detail?.password,
        email: data?.email,
        status: detail.status,
        userType: data?.userType,
      };
      dispatch(updateUserProfile(dataObj, userType));
      // redirect("/user");
    }
  };
  return (
    // sjfhsdakjf
    <div className="">
      <div className="col-md-6">
        {/* <div className='form-group row'>
								<label className='col-sm-3 col-form-label'>User Type</label>
								<div className='col-sm-9'>
									<select
										name='User_type'
										className='form-control'
											>
										<option value='true' name='active'>
											Select From Drop Down
                  
										</option>
									</select>
								</div>
							</div> */}
      </div>

      {/* sdjkfj */}
      <div className="card-body">
        <div className="row">
          <div className="col-md-6">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">User Name</label>
              <div className="col-sm-9">
                <input
                  type="text"
                  className="form-control"
                  name="username"
                  value={detail?.username}
                  placeholder="User Name"
                  onChange={onChangeHandle}
                />
              </div>
            </div>
          </div>
          {/* <div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Email</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='email'
										value={detail?.email}
										placeholder='Enter Email'
										onChange={onChangeHandle}
									/>
								</div>
							</div>
						</div> */}
          <div className="col-md-6">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">First Name</label>
              <div className="col-sm-9">
                <input
                  type="text"
                  className="form-control"
                  name="firstName"
                  value={detail?.firstName}
                  placeholder="First Name"
                  onChange={onChangeHandle}
                />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Last Name</label>
              <div className="col-sm-9">
                <input
                  type="text"
                  className="form-control"
                  name="lastName"
                  value={detail?.lastName}
                  placeholder="Last Name"
                  onChange={onChangeHandle}
                />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Country Code:</label>
              <div className="col-sm-9">
                <select
                  name="countryCode"
                  className="form-control"
                  onChange={onChangeHandle}
                  value={detail?.countryCode}
                >
                  <option value="+965">+965</option>
                  <option value="+91">+91</option>
                </select>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Mobile Number</label>
              <div className="col-sm-9">
                <input
                  type="number"
                  className="form-control"
                  name="mobileNumber"
                  value={detail?.mobileNumber}
                  placeholder="Mobile Number"
                  onChange={onChangeHandle}
                />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Mobile Verified</label>
              <div className="col-sm-9">
                <select
                  name="mobileVerified"
                  className="form-control"
                  onChange={onChangeHandle}
                  value={detail?.mobileVerified}
                >
                  <option value={true} name="yes">
                    Yes
                  </option>
                  <option value={false} name="no">
                    No
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Status</label>
              <div className="col-sm-9">
                <select
                  name="status"
                  className="form-control"
                  onChange={onChangeHandle}
                  value={detail?.status}
                >
                  <option value="active" name="active">
                    Active
                  </option>
                  <option value="in-active" name="inactive">
                    Inactive
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Password</label>
              <div className="col-sm-9">
                <input
                  type="password"
                  className="form-control"
                  name="password"
                  value={detail.password}
                  placeholder="Enter Password"
                  onChange={onChangeHandle}
                />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Re-Password</label>
              <div className="col-sm-9">
                <input
                  type="password"
                  className="form-control"
                  name="rePassword"
                  value={detail.rePassword}
                  placeholder="Re-Confirm Password"
                  onChange={onChangeHandle}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="row float-right p-3">
            <button onClick={onSave} className="btn btn-grd-disabled mr-2">
              <i className="icofont icofont-save"></i> Save
            </button>
            <Link
              to={userType === 'user' ? '/user' : '/service-provider'}
              className="btn btn-outline-dark"
            >
              {' '}
              Cancel{' '}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsersAdd;
// export default UserAdd;
